<entity-management-layout
  *ngIf="!loading"
  [showTopButtons]="false"
  [showBottomButtons]="true"
  (saveClicked)="onSave()"
  [saveDisabled]="!payorPlanPermissions.canManage"
  (cancelClicked)="onCancelPayorFacilities()"
>
  <div content class="mt-5">
    <div class="mb-4">
      This payor plan is assigned to the following facilities.
    </div>
    <thera-client-side-list
      [gridContext]="gridContext"
      [rowData]="rowData"
      [hideGridLines]="true"
      [columnDefs]="columnDefs"
      [rowSelection]="'multiple'"
    ></thera-client-side-list>

    <h4
      class="mt-4 font-semibold mb-4 pb-2 border-b-[dark\_blue] border-b-2 border-solid; text-dark_blue"
    >
      Manage Assignment of Payor to Facilities
    </h4>
    <thera-hierarchy
      *ngIf="hierarchyData && payor"
      (facilitiesSelected)="onFacilitiesSelected($event)"
      [columnDefs]="hierarchyColumns"
      [corpId]="payor.corpid"
      [draggable]="false"
      [selectable]="true"
      [showAddLocationsButton]="false"
      [tableSelect]="true"
      [rowSelection]="'multiple'"
      [hierarchyData]="hierarchyData"
      [emitOnChange]="true"
      [disabled]="!payorPlanPermissions.canManage"
    ></thera-hierarchy>
  </div>
</entity-management-layout>
